import { AudienceTypeEnum } from 'app/library/grow/enums/audience-type.enum';
import { MaxBrainAudience } from './audience.model';

export class AudienceUpdateCommand {
    name?: string;
    is_default?: boolean;

    constructor(tempAudience: MaxBrainAudience) {
        if (tempAudience.name) {
            this.name = tempAudience.name;
        }

        // Automatic audiences reject `is_default` on PATCH (automatic_audience_cannot_be_default).
        // Default flags are managed via patchAudienceDefaultFlags.
        if (tempAudience.type !== AudienceTypeEnum.AUTOMATIC && tempAudience.isDefault != null) {
            this.is_default = tempAudience.isDefault;
        }
    }
}
